import { render, staticRenderFns } from "./total-ex-in.vue?vue&type=template&id=8f54d9e0&scoped=true"
import script from "./total-ex-in.vue?vue&type=script&lang=js"
export * from "./total-ex-in.vue?vue&type=script&lang=js"
import style0 from "./total-ex-in.vue?vue&type=style&index=0&id=8f54d9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f54d9e0",
  null
  
)

export default component.exports